import styled from 'styled-components';
import { Popover, StyledDialog } from '@zillow/constellation';

export const StyledEventPopover = styled(Popover)`
  ${StyledDialog} {
    max-height: initial;
    max-width: 385px;
    z-index: 90000; /* Lower than v10 Modal z-index tokens (100000+) */
  }
`;
